module.exports = __webpack_public_path__ + "static/media/logo_salonmanagement.4edbec17.png";